module.exports = __webpack_public_path__ + "static/media/coffee.8d554acf.jpg";